<div class="grade-fill-form" [class.passive]="!_object">
    @if (_object) {
        <div class="grade-fill-form__header">
            <div class="grade-fill-form__excel" (click)="onExcelClick()">
                @if (_busy) {
                    <mat-progress-spinner [diameter]="19" mode="indeterminate"></mat-progress-spinner>
                    <!--          Загрузка...-->
                } @else {
                    <svg
                        width="19" height="19" viewBox="0 0 19 19" fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                    >
                        <mask
                            id="mask0_0_424" style="mask-type:alpha" maskUnits="userSpaceOnUse" x="0" y="0"
                            width="19"
                            height="19"
                        >
                            <rect width="18.3415" height="18.3415" fill="#D9D9D9"/>
                        </mask>
                        <g mask="url(#mask0_0_424)">
                            <path
                                d="M14.5204 14.5202H6.11393C5.69361 14.5202 5.33378 14.3706 5.03446 14.0712C4.73514 13.7719 4.58548 13.4121 4.58548 12.9918V2.29259C4.58548 1.87226 4.73514 1.51244 5.03446 1.21311C5.33378 0.913791 5.69361 0.76413 6.11393 0.76413H11.4635L16.0489 5.3495V12.9918C16.0489 13.4121 15.8992 13.7719 15.5999 14.0712C15.3006 14.3706 14.9408 14.5202 14.5204 14.5202ZM10.6993 6.11372V2.29259H6.11393V12.9918H14.5204V6.11372H10.6993ZM3.05702 17.5771C2.63669 17.5771 2.27687 17.4275 1.97755 17.1282C1.67823 16.8288 1.52856 16.469 1.52856 16.0487V5.3495H3.05702V16.0487H11.4635V17.5771H3.05702Z"
                                fill="#272B37"
                            />
                        </g>
                    </svg>
                }
                <span>Excel</span>
                @if (canUpload) {
                    <button
                        type="button"
                        class="grade-fill-form__upload"
                        [disabled]="uploading"
                        (click)="$event.stopPropagation(); importFile(fileInput)">
                        @if (uploading) {
                            <mat-progress-spinner
                                [diameter]="19"
                                mode="indeterminate"
                            ></mat-progress-spinner>
                        } @else {
                            <img
                                src="https://img.icons8.com/?size=19&id=82709&format=png"
                                alt=""
                                width="19"
                                height="19">
                        }

                        <span>Загрузка значений</span>
                    </button>

                    <input
                        type="file"
                        hidden
                        #fileInput
                        accept=".xlsx,.xls"
                        (click)="$event.stopPropagation()"
                        (change)="onFileDownload($event)">
                }

                @if ((currentUser | async)?.rights?.create?.no_violations) {
                    <button
                        class="no-violations-button"
                        (click)="onWithoutRemarksClick($event)"
                    >
                        Без нарушений
                    </button>
                }
            </div>
            <div class="grade-fill-form__label" [class.completed]="filledValues === _object.indexValues.length">
                Внесено {{ filledValues }} значений из {{ _object.indexValues.length }}
            </div>
        </div>
    }
    <form [formGroup]="form" class="grade-fill-form__form">
        <div
            class="grade-fill-form__list" pasAccessRole="indicator_indices"
            [mode]="mode"
        >
            <div class="grade-fill-form__list-search">
                <mat-icon>search</mat-icon>
                <input
                    class="grade-fill-form__input" type="text" matInput [formControlName]="'search'"
                    placeholder="Поиск"
                >
            </div>

            <ol class="grade-fill-form__list-list">
                @for (f of filtered$ | async; track f; let i = $index) {
                    <li
                        class="grade-fill-form__list-item"
                        [class.commented]="f.comment"
                        (click)="setIndex(f, i)"
                        [class.active]="currentIndex() === f"
                    >
                        <div class="grade-fill-form__list-name">
                            {{ i + 1 }}. {{ f.index.name }} ({{ f.index.shortName }})
                        </div>
                        <div class="grade-fill-form__list-value">
                            {{ f.value }} {{ f.valueItem?.name }}
                        </div>
                        <div class="grade-fill-form__list-complete">
                            @if (f.value !== undefined && f.value !== null || f?.valueItem?.name) {
                                <mat-icon svgIcon="pas-icon-true"></mat-icon>
                            } @else {
                                <mat-icon svgIcon="pas-icon-false"></mat-icon>
                            }
                        </div>

                    </li>
                    <div>
                        <div class="grade-fill-form__value-wrapper" [attr.open]="currentOrderIndex() === i">
                            <div>
                                <div class="grade-fill-form__value" pasAccessRole="enter_data"
                                     [mode]="mode">
                                    <div class="grade-fill-form__value-header">
                                        <mat-icon svgIcon="pas-icon-activity_zone"></mat-icon>
                                        <span>
                                            @if (currentIndex()?.index?.fillType === 'Ias_Sport') {
                                            Данные ИАС Спорт
                                            } @else if (currentIndex()?.index?.fillType === 'List_Select') {
                                            Данные из информационных систем
                                            } @else {
                                            Введите данные
                                            }
                                        </span>
                                    </div>
                                    @if (currentIndex()?.index?.fillType === 'Number_Enter') {
                                    <div class="grade-fill-form__input-container">
                                        <input type="number"
                                               class="grade-fill-form__input grade-fill-form__input--gray grade-fill-form__input--limit"
                                               [formControlName]="'value'" placeholder="Введите данные">
                                        <span>{{ currentIndex()?.index?.unit?.name }}</span>
                                    </div>
                                    }
                                    @if (currentIndex()?.index?.fillType === 'List_Select') {
                                    <div class="grade-fill-form__input-container" data-enabled="false">
                                        <div class="grade-fill-form__radio-list">
                                            @for (i of currentIndex()?.index?.indexItems; track i.id) {
                                            <label>
                                                <input [id]="'radio'+i.id"
                                                       type="radio"
                                                       [checked]="i.id === currentIndex()?.valueItem?.id"
                                                       disabled>
                                                <span>{{ i.name }}</span>
                                            </label>
                                            }
                                        </div>
                                    </div>
                                    }
                                    @if (currentIndex()?.index?.fillType === 'Ias_Sport') {
                                    <div class="grade-fill-form__input-container" data-enabled="false">
                                        <input type="number"
                                               [disabled]="true"
                                               class="grade-fill-form__input grade-fill-form__input--gray grade-fill-form__input--limit"
                                               [formControlName]="'value'">
                                        <span>{{ currentIndex()?.index?.unit?.name }}</span>
                                        <!--                                            <button class="grade-fill-form__button">Данные ИАС спорт</button>-->
                                    </div>
                                    }
                                </div>

                                <div
                                    class="grade-fill-form__comment" pasAccessRole="index_comment"
                                    [mode]="mode"
                                >
                                    <input
                                        class="grade-fill-form__input" [formControlName]="'comment'"
                                        placeholder="Комментарий"
                                    >
                                </div>
                            </div>
                        </div>
                    </div>
                }
            </ol>
        </div>
    </form>

    <br/>

</div>
